import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=6f7d4c51&scoped=true"
import script from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=6f7d4c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7d4c51",
  null
  
)

export default component.exports
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QKnob from 'quasar/src/components/knob/QKnob.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBadge,QIcon,QCard,QKnob,QTooltip,QInnerLoading,QSpinner});
